import './style/index.less';
import PluginComponent from './PluginComponent';

export * from './PluginComponent';

export default PluginComponent;
